setUserDataLanguageAlertBarAcceptedAction